import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { MediaRecorderComponent } from './media-recorder.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  declarations: [
    MediaRecorderComponent,
  ],
  exports: [
    MediaRecorderComponent,
  ],
})
export class MediaRecorderModule { }
